import { Component } from '@angular/core';

@Component({
  selector: 'app-social-proof',
  imports: [],
  templateUrl: './social-proof.component.html',
  styleUrl: './social-proof.component.scss',
})
export class SocialProofComponent {}
